import { useLayoutEffect, useEffect, useState, useContext } from "react";
import thousandSeparator from "../../../utils/ThousandSeparator";
import { MinuteSecondAudience } from "./MinuteSecondAudience";
import { UiContext } from "../../../context/UiContext";

export function MinuteGraphicLine({ heading, lastAudience, data, divMinute }) {

  const {
    isMobile,
    hasShortHeightDetail,
    minuteHeaderWidthAbsolute,
    calculateEmissorasColumn } = useContext(UiContext);

  let menu = document.getElementsByClassName("menu")[0];
  let divDate = document.getElementsByClassName("divDate")[0];
  let tableTitleHeight = parseFloat(divDate != undefined ? getComputedStyle(divDate).height : '0');
  let chartTopPadding = parseFloat(menu != undefined ? getComputedStyle(menu).height : '0');

  const getChartLineHeight = () => {
    let chartHeight = 240;
    let chartPercentWindowMobile = 44.15;
    let deviceRatio = window.devicePixelRatio > 1 ? 1.25 : 1;
    if (hasShortHeightDetail) {
      if (window.innerHeight <= 320) {
        return 0;
      }
      if (window.innerHeight <= 450) {
        return window.innerHeight * (chartPercentWindowMobile * deviceRatio) / 100 - chartTopPadding - tableTitleHeight;
      }
    }
    if(isMobile){
        return window.innerHeight * (30 * deviceRatio) / 100 - chartTopPadding - tableTitleHeight;
    }
    return chartHeight + (chartHeight * deviceRatio / 100);
  };

  const chartHeight = getChartLineHeight();
  let maxPixelValue = chartHeight - chartTopPadding - tableTitleHeight;

  let tableColumnWidth = calculateEmissorasColumn(heading?.enabled);
  const [widthPage, setWidthPage] = useState(window.innerWidth);

  function updateWidth() {
    setWidthPage(window.innerWidth);
  }
  window.addEventListener("resize", updateWidth);
  useLayoutEffect(() => { }, []);

  useEffect(() => { }, [widthPage]);

  const getMaxValue = (data) => {
    let maxValue = 0;
    data.forEach(function (row, rowIndex) {
      if (rowIndex >= 30) {
        return;
      }
      row.forEach(function (cell, index) {
        if (index < 4) return;
        let value = parseFloat(cell);
        if (!isNaN(value))
          maxValue = Math.max(maxValue, value);
      });
    });
    return maxValue;
  }
  const criaGrafico = (width, data, index, lastAudience, head) => {
    let maxValue = getMaxValue(data);
    let lineChartWidth = Math.floor(width); //228;
    let lineChartHeight = maxPixelValue - 5; //182;
    let dataHistory = data.map(row => isNaN(parseFloat(row[index])) ? 0 : parseFloat(row[index])).reverse();


    let semBaseMinima = false;
    if (dataHistory.some(v => v === null || isNaN(v))) {
      semBaseMinima = true;
    }

    //É realizado esse if porque no realtime só trabalha com 30 e aqui está trabalhando com 31
    if (dataHistory.length > 30)
      dataHistory.pop();
    // Remove valores NaN ou null de dataHistory
    dataHistory = dataHistory.filter(v => v !== null && !isNaN(v));
    //É composto o linePath para ser utilizado no svg
    let linePath = '';
    dataHistory.forEach((value, rowIndex) => {
      if (
        (parseInt(data[rowIndex][3]) === 0)
      ) {
        return null;
      }
      let startIndex = 0;
      let pX = 1 - ((rowIndex - startIndex) / (dataHistory.length - 1 - startIndex));
      let x = Math.round(pX * lineChartWidth);
      let pY = value / (maxValue === 0 ? 1 : maxValue);
      let y = Math.round((lineChartHeight - 2) - pY * (lineChartHeight - 2)) + 1;
      linePath += `L${x},${y} `;
    });
    linePath = linePath.length > 1 ? 'M' + linePath.substring(1) : '';
    let dotBottom = maxPixelValue - parseInt(linePath.replace(/[^,]{0,1000},([^\s]{0,1000})/, '$1')) - 2;
    const svgLine = (
      <svg
        width={lineChartWidth - 1}
        height={lineChartHeight}
        style={{
          position: 'absolute',
          shapeRendering: 'crispEdges',
          bottom: 0,
        }}
      >
        <path
          d={linePath}
          stroke={'white'}
          strokeWidth={1}
          fill={'none'}
        >
        </path>
      </svg>
    );
    const lineDot = (
      <div
        style={{
          display: !isNaN(dotBottom) ? 'block' : 'none',
          width: 5,
          height: 5,
          position: 'absolute',
          backgroundColor: '#FFFFFF',
          borderRadius: 5,
          bottom: dotBottom - 4.5,
          right: -1,
          zIndex: 1,
        }}
      ></div>
    );
    const tableChart = (
      <div
        className="tableGraphic"
        style={{
          backgroundColor: head.color,
          height: isNaN(dotBottom) ? "10px" : dotBottom - 3.5,
          width: width - 2,
          position: "relative",
          visibility: semBaseMinima ? "hidden" : "inherit",
        }}
        key={head.id}
      >
        <p
          style={{
            position: "absolute",
            right: "10px",
            marginTop: "-27px",
            textAlign: "right",
            color: "white",
          }}
        >
          {thousandSeparator.formatWithSeparator(
            lastAudience?.audRat
          )}
        </p>
        <MinuteSecondAudience audSh={lastAudience?.audSh} />
      </div>
    );
    return (
      <>
        {lineDot}
        {tableChart}
        {svgLine}
      </>
    );
  }
  const contentGraphic = (
    <table>
      <tbody>
        <td
          style={{
            verticalAlign: "bottom",
            padding: "0px",
            height: `${chartHeight}px`,
            minWidth: minuteHeaderWidthAbsolute + "px",
            position: "relative",
          }}
        ></td>
        {heading?.enabled?.map((head, headID) => (
          <td
            key={head.id}
            style={{
              verticalAlign: "bottom",
              padding: "0px",
              height: `${chartHeight}px`,
              position: "relative",
            }}
          >
            {lastAudience?.map((lastAudience, lastAudienceID) =>
              headID + 4 === lastAudienceID ? (
                <>
                  {criaGrafico(tableColumnWidth, data, headID + 4, lastAudience, head)}
                </>
              ) : (
                ""
              )
            )}
          </td>
        ))}
      </tbody>
    </table>
  );

  return (
    <div
      id="chartLine"
      data-testid="chartLine"
      style={{
        height: chartHeight + "px",
        width: "100%",
        overflow: "hidden",
        display: "flex"
      }}
    >
      {contentGraphic}
    </div>
  );
}